import { saveOwner } from '@Services/api/businessOwner';
import { useMutation } from '@tanstack/react-query';

type SaveOwnerOnSuccess = Parameters<
  typeof useMutation<
    Awaited<ReturnType<typeof saveOwner>>,
    Error,
    Parameters<typeof saveOwner>[0],
    unknown
  >
>[0]['onSuccess'];

export const useSaveOwner = (onSuccess?: SaveOwnerOnSuccess) => {
  return useMutation({
    mutationFn: saveOwner,
    onSuccess,
  });
};
